import {
  Component,
  HostListener,
  inject,
  LOCALE_ID,
  OnInit,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { CartComponent } from '../../cart/cart/cart.component';
import { of } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenubarModule, CartComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] = [];
  menuActive: boolean = false;

  title = '';
  // baseHref = document.getElementsByTagName('base')[0].getAttribute('href');
  // languagePrefix = this.baseHref?.replaceAll('/', '') || 'es';
  languagePrefix = inject(LOCALE_ID);
  currentPath = window.location.pathname
    .replace('/es/', '')
    .replace('/en/', '');

  localeFlagKey: { es: string; en: string; de: string } = {
    es: 'es',
    en: 'uk',
    de: 'de',
  };

  ngOnInit() {
    const languageMenu = [];
    this.languagePrefix !== 'es' &&
      languageMenu.push({
        // label: 'Inglés',
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es" alt="Bandera Selección idioma Español">',
        styleClass: 'flag-menu',
        url: '/es/',
        target: '_self',
      });

    this.languagePrefix !== 'en' &&
      languageMenu.push({
        // label: 'Inglés',
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk" alt="Bandera Selección idioma Inglés">',
        styleClass: 'flag-menu',
        url: '/en/',
        target: '_self',
      });

    this.languagePrefix !== 'de' &&
      languageMenu.push({
        label:
          '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-de" alt="Bandera Selección idioma Alemán">',
        styleClass: 'flag-menu',
        url: '/de/',
        target: '_self',
      });
    // ? {
    //     // label: 'Inglés',
    //     label:
    //       '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
    //     styleClass: 'flag-menu',
    //     url: '/es/',
    //     target: '_self',
    //   }
    // : {},
    // this.languagePrefix !== 'en'
    //   ? {
    //       // label: 'Inglés',
    //       label:
    //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
    //       styleClass: 'flag-menu',
    //       url: '/en/',
    //       target: '_self',
    //     }
    //   : {},
    // this.languagePrefix !== 'de'
    //   ? {
    //       // label: 'Inglés',
    //       label:
    //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-de">',
    //       styleClass: 'flag-menu',
    //       url: '/de/',
    //       target: '_self',
    //     }
    //   : {};

    this.items = [
      // {
      //   label: $localize`:@@header.menu.home.label:Inicio`,
      //   // routerLink: '/',
      //   url: `${this.baseHref}` + $localize`:@@header.menu.home.path:home`,
      //   target: '_self',
      //   styleClass: ['', 'inicio', 'home'].includes(this.currentPath)
      //     ? 'active'
      //     : '',
      // },
    ];

    this.languagePrefix != 'de' &&
      this.items.push({
        label: $localize`:@@header.menu.productos.label:Inicio`,
        routerLink: '/seguro-buceo',
      });

    this.items.push(
      {
        label: $localize`:@@header.menu.scubamedic.label:Historia`,
        routerLink: '/scubamedic',
      },
      {
        label: $localize`:@@header.menu.dive-pro.label:Horario`,
        routerLink: '/dive-pro',
      },
      {
        label: $localize`:@@header.menu.sinister.label:Galería`,
        routerLink: '/caso-accidente',
      },
  

    );

    this.languagePrefix != 'de' &&
      this.items.push(
        {
          label: $localize`:@@header.menu.team.label:Opiniones`,
          routerLink: '/nuestro-equipo',
        },

      );

    this.items.push({
      label: $localize`:@@header.menu.contact.label:Contacto`,
      routerLink: '/contacto',
    });

    this.languagePrefix != 'de' &&
      this.items.push(

        // {
        //   label: $localize`:@@header.menu.contact.label:Pedido`,
        //   routerLink: '/pedido',
        // },
        // ------------------------------------------------------------------
        // OCULTADO TEMPORAL
        // this.languagePrefix == 'es'
        //   ? {
        //       // label: 'Inglés',
        //       label:
        //         // '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
        //         'EN',
        //       styleClass: 'flag-menu',
        //       url: '/en/',
        //       target: '_self',
        //     }
        //   : {
        //       // label: 'Inglés',
        //       label: 'ES',
        //       styleClass: 'flag-menu',
        //       url: '/es/',
        //       target: '_self',
        //     },
        // ------------------------------------------------------------------
      );

    this.items.push(
      {
        label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${
          (this.localeFlagKey as any)[this.languagePrefix]
        }">`,
        // label: `Idioma`,
        icon: '',
        items: [
          // this.languagePrefix == 'en'
          //   ? {
          //       // label: 'Inglés',
          //       label:
          //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
          //       styleClass: 'flag-menu',
          //       url: '/en/',
          //       target: '_self',
          //     }
          //   : {
          //       // label: 'Inglés',
          //       label:
          //         '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
          //       styleClass: 'flag-menu',
          //       url: '/en/',
          //       target: '_self',
          //     },
          this.languagePrefix !== 'es'
            ? {
                // label: 'Inglés',
                label:
                  '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
                styleClass: 'flag-menu',
                url: '/es/',
                target: '_self',
              }
            : of(''),
          this.languagePrefix !== 'en'
            ? {
                // label: 'Inglés',
                label:
                  '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-uk">',
                styleClass: 'flag-menu',
                url: '/en/',
                target: '_self',
              }
            : of(''),
          this.languagePrefix !== 'de'
            ? {
                // label: 'Inglés',
                label:
                  '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-de">',
                styleClass: 'flag-menu',
                url: '/de/',
                target: '_self',
              }
            : of(''),
        ],
      }
      // {
      //   // label: 'Inglés',
      //   label:
      //     '<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-es">',
      //   styleClass: '',
      //   url: '/en/',
      //   target: '_self',
      // },
      // {
      //   label: `<img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" class="flag flag-${this.languagePrefix}">`,

      //   styleClass: '',
      //   url: this.languagePrefix,
      //   target: '_self',
      // },
    );
  }

  controlOverflow() {
    const mobileActive = document.body.querySelector('.p-menubar');
    mobileActive?.classList.contains('p-menubar-mobile-active')
      ? document.body.classList.add('p-overflow-hidden')
      : document.body.classList.remove('p-overflow-hidden');

    if (window.innerWidth > 960) {
      document.body.classList.remove('p-overflow-hidden');
    }
  }

  toggleMenu() {
    this.controlOverflow();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    // event: Event

    this.controlOverflow();
  }
}
